import { createAction, props } from '@ngrx/store';
import { AuthRequest, PersonDto } from 'src/app/api/models';

export const setCurrentUser = createAction(
  '[User/Storage] Set Current User',
  props<{ user: PersonDto }>()
);

export const loginUser = createAction(
  '[User/API] Login User',
  props<{ rememberme: boolean, body: AuthRequest }>()
);

export const loginUserSuccess = createAction(
  '[User/API] Login User Success',
  props<{ user: PersonDto }>()
);
export const loginUserError = createAction(
  '[User/API] Login User Error',
  props<{ error: any }>()
);

export const switchTenant = createAction(
  '[User/API] Switch Tenant',
  props<{ tenantDiscr: number }>()
);
export const switchTenantSuccess = createAction(
  '[User/API] Switch Tenant Success',
  props<{ user: PersonDto }>()
);
export const switchTenantError = createAction(
  '[User/API] Switch Tenant Success',
  props<{ user: PersonDto }>()
);
export const switchTenantBack = createAction(
  '[User/API] Switch Tenant Back',
  props<{ tenantDiscr: number }>()
);
export const switchTenantBackSuccess = createAction(
  '[User/API] Switch Tenant Back Success',
  props<{ user: PersonDto }>()
);

export const updateUser = createAction(
  '[User/API] Update user',
  props<{ user: PersonDto }>()
);

export const changeOrgUnit = createAction(
  '[User/API] Change OrgUnit',
  props<{ organizationalUnitId: string }>()
);
export const changeOrgUnitSuccess = createAction(
  '[User/API] Change OrgUnit Success',
  props<{ user: PersonDto }>()
);
export const changeOrgUnitError = createAction(
  '[User/API] Change OrgUnit Success',
  props<{ user: PersonDto }>()
);

export const logoutUser = createAction('[User/API] Logout User');
export const logoutUserSuccess = createAction('[User/API] Logout User Success');
